// extracted by mini-css-extract-plugin
module.exports = {"BrandsItems":"BrandsItems_BrandsItems__1fgnK"};